import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { CompanyBlockUnblockValidationSchema } from "../schemas/blockUnblockCompany.schema";

interface UseUnblockClientCompanyProps {
  companyId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useUnblockClientCompany = ({ companyId, onSuccess, onError }: UseUnblockClientCompanyProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation<void, AxiosError, CompanyBlockUnblockValidationSchema>({
    mutationKey: ['unblockCompany', companyId],
    mutationFn: async (data) => {
      await privateAxios.put(`/client/companies/${companyId}/unblock`, {
        company: data,
      });
    },
    onSuccess,
    onError,
  });
};

export default useUnblockClientCompany;
